import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import Header from "./header";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ReactPlayer from "react-player";
import { config } from "../App";

const VideoPage = () => {
  const [filter, setfilter] = useState([]);
  const [Allfilter, setAllfilter] = useState([]);
  const [upvotes, setupvotes] = useState("");
  const [downvotes, setdownvotes] = useState("");
  const params = useParams();

  useEffect(() => {
    const performAPICall = async () => {
      try {
        const response = await axios.get(
          `${config.endpoint}/videos/${params.id}`
        );
        setfilter(response.data);
        console.log(response.data);
        const res = await axios.get(`${config.endpoint}/videos/${params.id}`);
        setupvotes(res.data.votes.upVotes);
        setdownvotes(res.data.votes.downVotes);
        await axios.patch(`${config.endpoint}/videos/${params.id}/views`);
        return response;
      } catch (err) {
        if (err.response.status === 404) {
          console.log("Page not found");
        } else {
          console.log(err);
        }
      }
    };
    performAPICall();
  }, [params]);

  useEffect(() => {
    const performAPICall1 = async () => {
      try {
        const response1 = await axios.get(
          `${config.endpoint}/videos?genres=All`
        );
        setAllfilter(response1.data.videos);
        return response1;
      } catch (err) {
        if (err.response1.status === 404) {
          console.log("Page not found");
        } else {
          console.log(err);
        }
      }
    };
    performAPICall1();
  }, []);

  async function upvotesHandler() {
    try {
      const response3 = await axios.patch(
        `${config.endpoint}/videos/${params.id}/votes`,
        {
          vote: "upVote",
          change: "increase",
        }
      );
      setupvotes(response3.data.votes.upVotes);
    } catch {
      console.log("No video found with matching id");
    }
  }

  async function downvotesHandler() {
    try {
      const response3 = await axios.patch(
        `${config.endpoint}/videos/${params.id}/votes`,
        {
          vote: "downVote",
          change: "increase",
        }
      );
      setdownvotes(response3.data.votes.downVotes);
    } catch {
      console.log("No video found with matching id");
    }
  }

  return (
    <Box sx={{ background: "#181818" }}>
      <Header inVideoPage />
      <Container
        sx={{
          background: "#181818",
          width: "70%",
          height: "100%",
        }}
      >
        <Box
          className="container"
          sx={{
            background: "#181818",
            color: "white",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ReactPlayer controls url={filter.videoLink} />
        </Box>
        <Box
          sx={{
            height: "70px",
            width: "100%",
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box sx={{ textAlign: "left", color: "white", pt: "9px" }}>
            <Typography sx={{ fontSize: 19 }}>{filter.title}</Typography>
            <Box sx={{ display: "inline-flex" }}>
              <Typography sx={{ color: "#C2C2C2", fontSize: 14, p: "5px", pl: "0px" }}>
                {filter.viewCount} views
              </Typography>
              <span className="dot"> 
                <FiberManualRecordIcon sx={{ fontSize: 8 }} />{" "}
              </span>
              <Typography sx={{ color: "#C2C2C2", fontSize: 14, p: "5px" }}>
                {filter.contentRating}
              </Typography>
              <span className="dot">
                <FiberManualRecordIcon sx={{ fontSize: 8 }} />{" "}
              </span>
              <Typography sx={{ color: "#C2C2C2", fontSize: 14, p: "5px" }}>
                {filter.releaseDate}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              flexDirection: "row-reverse",
              height: "60px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "150px",
            }}
          >
            <button className="like-button" onClick={downvotesHandler}>
              <ThumbDownIcon sx={{ fontSize: 13, pr: "8px", pt: "2px" }} />
              {downvotes}
            </button>
            <button className="like-button" onClick={upvotesHandler}>
              <ThumbUpIcon sx={{ fontSize: 13, pr: "8px", pt: "2px" }} />
              {upvotes}
            </button>
          </Box>
        </Box>
        <Divider color="white" />
        <Box sx={{ pt: "20px" }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {Allfilter.map((item, index) => (
              <Grid item xs={2} sm={4} md={3} key={index}>
                <Link to={`/videos/${item._id}`}>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        height="140"
                        image={item.previewImage}
                        alt="green iguana"
                      />
                      <CardContent
                        sx={{ bgcolor: "#181818", textAlign: "left" }}
                      >
                        <Typography
                          gutterBottom
                          variant="h5"
                          component="div"
                          sx={{ fontSize: 14, color: "white" }}
                        >
                          {item.title}
                        </Typography>
                        <Typography variant="body2" color="#D1D5DA">
                          {item.releaseDate}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default VideoPage;
